<template>
  <page :loading="loading">
    <template #content>
      <SubTopBar></SubTopBar>
      <v-breadcrumbs
        :items="bcItems"
        divider=">"
        class="mt-1"
        large
        />
      <div class="content">
        <div class="mb-2 ml-5 font-weight-bold"> Organizations you are sharing information with: </div>
        <data-table 
          v-model="page" 
          class="921692row-pointer ml-3 elevation-1"
          :headers="headers"
          :hide-default-footer= true
          :items="orgs"
          @refresh="getAllAuthorizations"
          :rowClickEvent="rowOnClick"
          >
          <template v-slot:no-data/>
        </data-table>
      </div>
    </template>
  </page>
</template>

<script>
export default {
  data: () => ({
    page: 1,
    dialog: false,
    loading: true,
    headers: [
      { text: 'Organizations', sortable: true, value: 'grantedTo' },
    ],
    orgs: [],
  }),
  created() {
    this.getAllAuthorizations()
  },
  computed: {
    bcItems: function () {
      return [
        {},
        {
          text: "Shared Information",
          disabled: false,
          exact: true,
          href: `${this.$route.path}`
        },
      ]}
  },
  methods: {
    getAllAuthorizations() {
      this.$api.getAllAuthorizations(this.username, this.callBack(data=> {
        this.orgs = data
      }))
    },
    rowOnClick: function (item) {
      this.$router.push({ name: 'InfoShared', params: {globalId: item.grantedTo}})
    }
  },
  mounted() {
    this.loading = false
  }
}
</script>

<style scoped>
.content {
  margin: 10px;
  width: fit-content;
  max-width: 100%;
}
.row-pointer >>> tbody tr :hover {
  cursor: pointer
}
.content .v-data-table {
  width: 520px;
  max-width: 100%;
}
</style>